import React, { PropTypes } from 'react';
import classNames from 'classnames';

const ModeButtons = (props) => {
    const { mode, actions } = props;

    const editWrapMenuCss = classNames({
        'tabnav-wrap': true,
        'tabnav-wrap--edit': (mode === 'EDIT') ? true : false,
        'tabnav-wrap--preview': (mode === 'PREVIEW') ? true : false,
    });

    const editMenuCss = classNames({
        'tabnav': true,
        'tabnav--edit': (mode === 'EDIT') ? true : false,
        'tabnav--preview': (mode === 'PREVIEW') ? true : false,
    });

    const changeMode = (mode, e) => {
        e.preventDefault();
        actions.changeMode(mode);
    };

    return (
        <div className={editWrapMenuCss}>
            <div className={editMenuCss}>
                <a className={(mode === 'EDIT') ? 'tabnav__item -active' : 'tabnav__item'} onClick={changeMode.bind(this, 'EDIT')}>
                { (mode === 'PREVIEW') ? 'Close preview' : 'Edit mode' }
                </a>
                <a className={(mode === 'PREVIEW') ? 'tabnav__item -active' : 'tabnav__item'} onClick={changeMode.bind(this, 'PREVIEW')}>Preview</a>
            </div>
        </div>
    );
};

ModeButtons.propTypes = {
    mode: PropTypes.string.isRequired,
    actions: PropTypes.object.isRequired,
};

export default ModeButtons;



// WEBPACK FOOTER //
// ./src/_app/quick_response/components/Content/UI/ModeButtons.jsx